import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { api, getApiError } from "../../api/client";

export default function RegenerateScriptModal({ runId, onClose, onSuccess }) {
  const [rationale, setRationale]   = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError]           = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!rationale.trim()) { setError("Rationale is required."); return; }
    setError("");
    setSubmitting(true);
    try {
      await api.post(`/golive/scripts/${runId}/regenerate`, {
        rationale:         rationale.trim(),
        suggested_changes: [],
      });
      onSuccess();
    } catch (err) {
      setError(getApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="gl-modal-overlay" onClick={onClose}>
      <div className="gl-modal" style={{ width: 500 }} onClick={(e) => e.stopPropagation()}>
        <div>
          <h3 className="gl-modal-title">Re-run analysis</h3>
          <p className="text-sm text-slate-500 mt-1">
            Tell the AI what to change. A new script will be generated using this
            feedback alongside the approved proposal.
          </p>
        </div>

        {error && <div className="gl-error">{error}</div>}

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div className="flex flex-col gap-1.5">
            <p className="text-sm font-semibold text-slate-800">What should be changed?</p>
            <textarea
              className="gl-input text-sm"
              rows={5}
              value={rationale}
              onChange={(e) => setRationale(e.target.value)}
              placeholder="Cloud SQL tier should be db-n1-standard-1, not db-f1-micro. Cloud Run memory needs to be 2 GB to handle peak load."
              style={{ resize: "vertical" }}
            />
            <p className="text-xs text-slate-400">
              Be specific — the AI uses this rationale when regenerating the script.
            </p>
          </div>

          <div className="gl-modal-actions">
            <button type="button" className="gl-btn" onClick={onClose}>Cancel</button>
            <button type="submit" className="gl-btn primary" disabled={submitting}>
              <RefreshCw size={14} />
              {submitting ? "Submitting…" : "Re-run analysis"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
